
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { PoiChallenge } from "@/models/MapPois/ManHunt/ManhuntMapPoi";
import { cloneDeep } from "lodash";

@Component
class PoiChallengeFxTable extends Vue {
  @Prop({ default: true }) readonly content!: PoiChallenge;
  @Prop({ default: true }) readonly isEditingLocked!: boolean;
  searchFilter = "";
  busy = false;
  inputFxIncorrect: number[] = [];
  inputFxSuccess: number[] = [];
  inputFxFailure: number[] = [];
  contentClone = {} as PoiChallenge;
  fields = [
    {
      key: "slug",
      label: "FX Name",
      sortable: true,
    },
    {
      key: "incorrect",
      label: "On Incorrect",
      sortable: true,
    },
    {
      key: "failure",
      label: "On Failure",
      sortable: true,
    },
    {
      key: "success",
      label: "On Success",
      sortable: true,
    },
    {
      key: "description",
      label: "Description",
      sortable: true,
    },
  ];

  created(): void {
    this.contentClone = cloneDeep(this.content);
  }

  isHighlighted(item: any): boolean {
    if (this.content.on_success !== undefined) {
      if (
        this.content.on_success.fx !== undefined &&
        this.content.on_success.fx[item.slug] !== undefined &&
        this.content.on_success.fx[item.slug] != 0
      ) {
        return true;
      }
    }
    if (this.content.on_fail !== undefined) {
      if (
        this.content.on_fail.fx !== undefined &&
        this.content.on_fail.fx[item.slug] !== undefined &&
        this.content.on_fail.fx[item.slug] != 0
      ) {
        return true;
      }
    }
    if (this.content.on_incorrect !== undefined) {
      if (
        this.content.on_incorrect.fx !== undefined &&
        this.content.on_incorrect.fx[item.slug] !== undefined &&
        this.content.on_incorrect.fx[item.slug] != 0
      ) {
        return true;
      }
    }
    return false;
  }

  getRowCssClass(item: any): string {
    if (this.isHighlighted(item)) {
      return "highlight-row-pink";
    }
    return "";
  }

  getFxSuccessCount(fxName: string, index: number): void {
    if (
      this.content.on_success.active &&
      this.content.on_success.fx !== undefined
    ) {
      if (this.content.on_success.fx[fxName] !== undefined) {
        this.inputFxSuccess[index] = this.content.on_success.fx[fxName];
      } else {
        this.inputFxSuccess[index] = 0;
      }
    } else {
      this.inputFxSuccess[index] = 0;
    }
  }
  getFxIncorrectCount(fxName: string, index: number): void {
    if (
      this.content.on_incorrect.active &&
      this.content.on_incorrect.fx !== undefined
    ) {
      if (this.content.on_incorrect.fx[fxName] !== undefined) {
        this.inputFxIncorrect[index] = this.content.on_incorrect.fx[fxName];
      } else {
        this.inputFxIncorrect[index] = 0;
      }
    } else {
      this.inputFxIncorrect[index] = 0;
    }
  }
  getFxFailureCount(fxName: string, index: number): void {
    if (this.content.on_fail.active && this.content.on_fail.fx !== undefined) {
      if (this.content.on_fail.fx[fxName] !== undefined) {
        this.inputFxFailure[index] = this.content.on_fail.fx[fxName];
      } else {
        this.inputFxFailure[index] = 0;
      }
    } else {
      this.inputFxFailure[index] = 0;
    }
  }

  onValueChanged(row: any): void {
    if (row.field.key == "incorrect") {
      if (this.inputFxIncorrect[row.index] != 0) {
        if (this.contentClone.on_incorrect.fx === undefined) {
          this.contentClone.on_incorrect = {
            active: true,
            fx: { [row.item.slug]: this.inputFxIncorrect[row.index] },
          };
        } else {
          this.contentClone.on_incorrect.fx![
            row.item.slug
          ] = this.inputFxIncorrect[row.index];
        }
      } else {
        if (this.contentClone.on_incorrect.fx![row.item.slug] !== undefined) {
          delete this.contentClone.on_incorrect.fx![row.item.slug];
        }
        if (Object.keys(this.contentClone.on_incorrect.fx!).length <= 0) {
          this.contentClone.on_incorrect.active = false;
        }
      }
    }
    if (row.field.key == "failure") {
      if (this.inputFxFailure[row.index] != 0) {
        if (this.contentClone.on_fail.fx === undefined) {
          this.contentClone.on_fail = {
            active: true,
            fx: { [row.item.slug]: this.inputFxFailure[row.index] },
          };
        } else {
          this.contentClone.on_fail.fx![row.item.slug] = this.inputFxFailure[
            row.index
          ];
        }
      } else {
        if (this.contentClone.on_fail.fx![row.item.slug] !== undefined) {
          delete this.contentClone.on_fail.fx![row.item.slug];
        }
        if (Object.keys(this.contentClone.on_fail.fx!).length <= 0) {
          this.contentClone.on_fail.active = false;
        }
      }
    }
    if (row.field.key == "success") {
      if (this.inputFxSuccess[row.index] != 0) {
        if (this.contentClone.on_success.fx === undefined) {
          this.contentClone.on_success = {
            active: true,
            fx: { [row.item.slug]: this.inputFxSuccess[row.index] },
          };
        } else {
          this.contentClone.on_success.fx![row.item.slug] = this.inputFxSuccess[
            row.index
          ];
        }
      } else {
        if (this.contentClone.on_success.fx![row.item.slug] !== undefined) {
          delete this.contentClone.on_success.fx![row.item.slug];
        }
        if (Object.keys(this.contentClone.on_success.fx!).length <= 0) {
          this.contentClone.on_success.active = false;
        }
      }
    }
    this.$emit("updateTempObject", this.contentClone);
  }

  @Watch("content")
  onContentChange(value: PoiChallenge): void {
    this.contentClone = value;
  }
}

export default PoiChallengeFxTable;
